/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import { HealthFragmentDoc } from "../../../shared/api/health/fragments.generated"
import * as Types from "../../../shared/types/__generated__/graphql"
import {
  DeliveryTimeActiveImportFragmentDoc,
  ProductInformationFragmentDoc
} from "./product-information.fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProductInformationQueryVariables = Exact<{
  variantKey: string
  configurationKey: string
  dimensioningKey: string
}>

export type ProductInformationQuery = {
  __typename: "Query"
  productInformation?: {
    __typename: "ProductInformation"
    productType: string
    variantKey: string
    configurationKey?: string | null
    title: string
    shortTitle: string
    productKind: string
    price?: number | null
    priceGroup?: string | null
    addons?: Array<{
      __typename: "ProductInformation"
      productType: string
      variantKey: string
      configurationKey?: string | null
      title: string
      shortTitle: string
      productKind: string
      price?: number | null
      priceGroup?: string | null
      attributes: Array<{
        __typename: "ProductAttribute"
        value: string
        label: string
        valueShort?: string | null
      }>
      picture?: {
        __typename: "ProductPicture"
        url: string
        title?: string | null
        alternativeText?: string | null
      } | null
      quickInfos?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      generalDescription?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      variantDescription?: {
        __typename: "ProductInformationTextField"
        label: string
        value: string
      } | null
      attributesTable?: {
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      } | null
      dimensioning?: {
        __typename: "ProductDimensioning"
        supplementaryText?: string | null
        environmentalAttributes?: Array<{
          __typename: "ProductAttribute"
          value: string
          label: string
          valueShort?: string | null
        }> | null
        physicalAttributes?: Array<{
          __typename: "PhysicalAttribute"
          value?: number | null
          unit?: string | null
          label: string
        }> | null
        physicalTables?: Array<{
          __typename: "DataTable"
          description?: string | null
          body?: Array<Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null> | null
          header?: Array<{
            __typename: "DataTableCell"
            index?: number | null
            key?: string | null
            value?: any
          }> | null
        }> | null
      } | null
      deliveryTime?: {
        __typename: "ProductDeliveryTime"
        type: string
        days?: number | null
        week?: number | null
        quarter?: number | null
        year?: number | null
      } | null
    }> | null
    attributes: Array<{
      __typename: "ProductAttribute"
      value: string
      label: string
      valueShort?: string | null
    }>
    picture?: {
      __typename: "ProductPicture"
      url: string
      title?: string | null
      alternativeText?: string | null
    } | null
    quickInfos?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    generalDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    variantDescription?: {
      __typename: "ProductInformationTextField"
      label: string
      value: string
    } | null
    attributesTable?: {
      __typename: "DataTable"
      description?: string | null
      body?: Array<Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null> | null
      header?: Array<{
        __typename: "DataTableCell"
        index?: number | null
        key?: string | null
        value?: any
      }> | null
    } | null
    dimensioning?: {
      __typename: "ProductDimensioning"
      supplementaryText?: string | null
      environmentalAttributes?: Array<{
        __typename: "ProductAttribute"
        value: string
        label: string
        valueShort?: string | null
      }> | null
      physicalAttributes?: Array<{
        __typename: "PhysicalAttribute"
        value?: number | null
        unit?: string | null
        label: string
      }> | null
      physicalTables?: Array<{
        __typename: "DataTable"
        description?: string | null
        body?: Array<Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null> | null
        header?: Array<{
          __typename: "DataTableCell"
          index?: number | null
          key?: string | null
          value?: any
        }> | null
      }> | null
    } | null
    deliveryTime?: {
      __typename: "ProductDeliveryTime"
      type: string
      days?: number | null
      week?: number | null
      quarter?: number | null
      year?: number | null
    } | null
  } | null
}

export type ProductInformationHealthQueryVariables = Exact<{
  [key: string]: never
}>

export type ProductInformationHealthQuery = {
  __typename: "Query"
  productInformationHealth?: {
    __typename: "Health"
    isAvailable: boolean
  } | null
}

export type DeliveryTimeActiveImportQueryVariables = Exact<{
  [key: string]: never
}>

export type DeliveryTimeActiveImportQuery = {
  __typename: "Query"
  deliveryTimeActiveImport?: {
    __typename: "DeliveryTimeActiveImport"
    contentLength: number
    importedAt: string
    uploaderName: string
    uploaderEmail: string
    fileName: string
    readUrl: string
    status: string
  } | null
}

export const ProductInformationDocument = gql`
  query ProductInformation(
    $variantKey: String!
    $configurationKey: String!
    $dimensioningKey: String!
  ) {
    productInformation(
      variantKey: $variantKey
      configurationKey: $configurationKey
      dimensioningKey: $dimensioningKey
    )
      @rest(
        type: "ProductInformation"
        endpoint: "productInformation"
        path: "/product-information/aggregate/{args.variantKey}?configurationKey={args.configurationKey}&dimensioningKey={args.dimensioningKey}"
      ) {
      ...ProductInformation
    }
  }
  ${ProductInformationFragmentDoc}
`

/**
 * __useProductInformationQuery__
 *
 * To run a query within a React component, call `useProductInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInformationQuery({
 *   variables: {
 *      variantKey: // value for 'variantKey'
 *      configurationKey: // value for 'configurationKey'
 *      dimensioningKey: // value for 'dimensioningKey'
 *   },
 * });
 */
export function useProductInformationQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProductInformationQuery,
    ProductInformationQueryVariables
  > &
    (
      | { variables: ProductInformationQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductInformationQuery,
    ProductInformationQueryVariables
  >(ProductInformationDocument, options)
}
export function useProductInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductInformationQuery,
    ProductInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductInformationQuery,
    ProductInformationQueryVariables
  >(ProductInformationDocument, options)
}
// @ts-ignore
export function useProductInformationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductInformationQuery,
    ProductInformationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductInformationQuery,
  ProductInformationQueryVariables
>
export function useProductInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductInformationQuery,
        ProductInformationQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductInformationQuery | undefined,
  ProductInformationQueryVariables
>
export function useProductInformationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductInformationQuery,
        ProductInformationQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductInformationQuery,
    ProductInformationQueryVariables
  >(ProductInformationDocument, options)
}
export type ProductInformationQueryHookResult = ReturnType<
  typeof useProductInformationQuery
>
export type ProductInformationLazyQueryHookResult = ReturnType<
  typeof useProductInformationLazyQuery
>
export type ProductInformationSuspenseQueryHookResult = ReturnType<
  typeof useProductInformationSuspenseQuery
>
export type ProductInformationQueryResult = Apollo.QueryResult<
  ProductInformationQuery,
  ProductInformationQueryVariables
>
export const ProductInformationHealthDocument = gql`
  query ProductInformationHealth {
    productInformationHealth
      @rest(
        type: "Health"
        endpoint: "health"
        path: "/product-information/health"
      ) {
      ...Health
    }
  }
  ${HealthFragmentDoc}
`

/**
 * __useProductInformationHealthQuery__
 *
 * To run a query within a React component, call `useProductInformationHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductInformationHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductInformationHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductInformationHealthQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ProductInformationHealthQuery,
    ProductInformationHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ProductInformationHealthQuery,
    ProductInformationHealthQueryVariables
  >(ProductInformationHealthDocument, options)
}
export function useProductInformationHealthLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductInformationHealthQuery,
    ProductInformationHealthQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ProductInformationHealthQuery,
    ProductInformationHealthQueryVariables
  >(ProductInformationHealthDocument, options)
}
// @ts-ignore
export function useProductInformationHealthSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductInformationHealthQuery,
    ProductInformationHealthQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ProductInformationHealthQuery,
  ProductInformationHealthQueryVariables
>
export function useProductInformationHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductInformationHealthQuery,
        ProductInformationHealthQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ProductInformationHealthQuery | undefined,
  ProductInformationHealthQueryVariables
>
export function useProductInformationHealthSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ProductInformationHealthQuery,
        ProductInformationHealthQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ProductInformationHealthQuery,
    ProductInformationHealthQueryVariables
  >(ProductInformationHealthDocument, options)
}
export type ProductInformationHealthQueryHookResult = ReturnType<
  typeof useProductInformationHealthQuery
>
export type ProductInformationHealthLazyQueryHookResult = ReturnType<
  typeof useProductInformationHealthLazyQuery
>
export type ProductInformationHealthSuspenseQueryHookResult = ReturnType<
  typeof useProductInformationHealthSuspenseQuery
>
export type ProductInformationHealthQueryResult = Apollo.QueryResult<
  ProductInformationHealthQuery,
  ProductInformationHealthQueryVariables
>
export const DeliveryTimeActiveImportDocument = gql`
  query DeliveryTimeActiveImport {
    deliveryTimeActiveImport
      @rest(
        type: "DeliveryTimeActiveImport"
        endpoint: "deliveryTimeActiveImport"
        path: "/product-information/delivery-times/current-import"
      ) {
      ...DeliveryTimeActiveImport
    }
  }
  ${DeliveryTimeActiveImportFragmentDoc}
`

/**
 * __useDeliveryTimeActiveImportQuery__
 *
 * To run a query within a React component, call `useDeliveryTimeActiveImportQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryTimeActiveImportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryTimeActiveImportQuery({
 *   variables: {
 *   },
 * });
 */
export function useDeliveryTimeActiveImportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DeliveryTimeActiveImportQuery,
    DeliveryTimeActiveImportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    DeliveryTimeActiveImportQuery,
    DeliveryTimeActiveImportQueryVariables
  >(DeliveryTimeActiveImportDocument, options)
}
export function useDeliveryTimeActiveImportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DeliveryTimeActiveImportQuery,
    DeliveryTimeActiveImportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    DeliveryTimeActiveImportQuery,
    DeliveryTimeActiveImportQueryVariables
  >(DeliveryTimeActiveImportDocument, options)
}
// @ts-ignore
export function useDeliveryTimeActiveImportSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    DeliveryTimeActiveImportQuery,
    DeliveryTimeActiveImportQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  DeliveryTimeActiveImportQuery,
  DeliveryTimeActiveImportQueryVariables
>
export function useDeliveryTimeActiveImportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeliveryTimeActiveImportQuery,
        DeliveryTimeActiveImportQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  DeliveryTimeActiveImportQuery | undefined,
  DeliveryTimeActiveImportQueryVariables
>
export function useDeliveryTimeActiveImportSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        DeliveryTimeActiveImportQuery,
        DeliveryTimeActiveImportQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    DeliveryTimeActiveImportQuery,
    DeliveryTimeActiveImportQueryVariables
  >(DeliveryTimeActiveImportDocument, options)
}
export type DeliveryTimeActiveImportQueryHookResult = ReturnType<
  typeof useDeliveryTimeActiveImportQuery
>
export type DeliveryTimeActiveImportLazyQueryHookResult = ReturnType<
  typeof useDeliveryTimeActiveImportLazyQuery
>
export type DeliveryTimeActiveImportSuspenseQueryHookResult = ReturnType<
  typeof useDeliveryTimeActiveImportSuspenseQuery
>
export type DeliveryTimeActiveImportQueryResult = Apollo.QueryResult<
  DeliveryTimeActiveImportQuery,
  DeliveryTimeActiveImportQueryVariables
>
